module.exports = "/images/close-btn-small.svg?cd453e14a8c05a59db132153e437ecd3";